export const TOOL_IDS = {
  SELECT: 'select',
  BRUSH: 'brush',
  TEXT: 'text',
  RECT: 'rectangle',
  CIRCLE: 'circle',
  LINE: 'line',
  CROP: 'crop',
};

export const TOOL_DEFS = [
  { id: TOOL_IDS.SELECT, name: 'Select' },
  { id: TOOL_IDS.BRUSH, name: 'Brush' },
  { id: TOOL_IDS.TEXT, name: 'Text' },
  { id: TOOL_IDS.RECT, name: 'Rectangle' },
  { id: TOOL_IDS.CIRCLE, name: 'Circle' },
  { id: TOOL_IDS.LINE, name: 'Line' },
  { id: TOOL_IDS.CROP, name: 'Crop' },
];
